export const WHITE_FRIDAY_STARTS_AT = new Date('2026-11-01T00:00:00.000+02:00');
export const WHITE_FRIDAY_EXPIRES_AT = new Date('2026-11-30T23:59:59.999+02:00');
export const WHITE_FRIDAY_COUNTRIES = ['SA', 'AE', 'KW', 'OM', 'QA', 'BH', 'LB'];
export const WHITE_FRIDAY_AMOUNT = {
  SA: 'SAR 1,000',
  AE: 'AED 1,000',
  QA: 'QAR 1,500',
  KW: 'KWD 82',
  LB: 'USD 266',
  OM: 'OMR 100',
  BH: 'BHD 100',
};
export const isWhiteFridayActive = () => {
  const now = Date.now();
  return now >= WHITE_FRIDAY_STARTS_AT.getTime() && now <= WHITE_FRIDAY_EXPIRES_AT.getTime();
};
